<template lang="pug">
    .row.job-list-container
        .col-12
            .job-list
                .scrollable(:class="{ 'show-all': showAll }")
                    .job-list__item(v-for='(job) in filtered', v-bind:key='job.id')
                        router-link(v-bind:to='job.url')
                            .row.job-list__container
                                .col-12.job-list__title {{job.title}}
                                .col-12.job-list__category
                                    | {{job.category}}
                                    span.job-list__arrow
                                        img(src='../assets/home/icon__arrow-right.png')
                    .job-list__item.other
                        router-link(to='/jobs/other/apply')
                            a.row.job-list__container
                                .col-12.job-list__title {{btn_others}}
                                .col-12.job-list__category
                                    span.job-list__arrow.job-list__arrow-other
                                        img(src='../assets/home/icon__arrow-right.png')
                .remarks(v-if="!showAll")
                    span(v-text="remarks", @click="disableScroll")
</template>

<script>
  export default {
    name: "JobList",
    props: {
      keyword: String,
      category: String,
      btn_search: String,
      btn_others: String,
      jobs: Array,
      locale: String,
    },
    data() {
      return {
        base_url: 'jobs',
        showAll: false
      }
    },
    computed: {
      remarks() {
        return this.locale === 'en' ? 'Find more' : '查看更多'
      },
      morphed_jobs() {
        const REGEX_CHINESE = /[\u4e00-\u9fff]|[\u3400-\u4dbf]|[\u{20000}-\u{2a6df}]|[\u{2a700}-\u{2b73f}]|[\u{2b740}-\u{2b81f}]|[\u{2b820}-\u{2ceaf}]|[\uf900-\ufaff]|[\u3300-\u33ff]|[\ufe30-\ufe4f]|[\uf900-\ufaff]|[\u{2f800}-\u{2fa1f}]/u;
        const jobs = this.jobs.map(job => ({
          ...job,
          'category': job.categories.length ? job.categories[0].name : '',
          'url': `/${this.base_url}/${job.id}`
        }));

        // Chinese has higher priority
        const compareLang = (a, b) => {
          if (REGEX_CHINESE.test(a)) {
            return REGEX_CHINESE.test(b) ? 0 : 1;
          } else {
            return REGEX_CHINESE.test(b) ? -1 : 0;
          }
        };
        return this.locale === 'en'
          ? jobs.sort((a, b) =>
            compareLang(a.category, b.category) || a.category.localeCompare(b.category)
            || compareLang(a.title, b.title) || a.title.localeCompare(b.title))
          : jobs.sort((a, b) =>
            compareLang(b.category, a.category) || a.category.localeCompare(b.category)
            || compareLang(b.title, a.title) || a.title.localeCompare(b.title));
      },
      filtered() {
        return this.morphed_jobs.filter(job =>
          this.keywordFilter(job, this.keyword) &&
          this.categoryFilter(job, this.category)
        );
      }
    },
    methods: {
      disableScroll() {
        this.showAll = true
      },
      keywordFilter(job, keyword) {
        return this.titleFilter(job, keyword) || this.categoryFilter(job, keyword)
      },
      titleFilter(job, title) {
        return !title || (job.title && this.insensitiveFilter(job.title, title))
      },
      categoryFilter(job, category) {
        return !category || (job.category && job.category === category)
      },
      insensitiveFilter(target, include) {
        return target.toLowerCase().includes(include.toLowerCase())
      }
    }
  };
</script>

<style lang="sass" scoped>
    @import "../../node_modules/bootstrap/scss/functions"
    @import "../assets/styles/CustomVariables"
    @import "../assets/styles/wysiwyg"
    @import "../assets/styles/common"
    @import "../../node_modules/bootstrap/scss/variables"
    @import "../../node_modules/bootstrap/scss/mixins"
    @import "../../node_modules/bootstrap/scss/grid"

    .job-list
        .scrollable
            overflow: hidden scroll
            @supports not (-webkit-overflow-scrolling: touch)
                max-height: 480px
            &.show-all
                max-height: none

            &::-webkit-scrollbar
                width: 10px
                height: 6px

            &::-webkit-scrollbar-track
                border-radius: 20px
                background: transparent

            &::-webkit-scrollbar-thumb
                border-radius: 10px
                background: rgba(0, 0, 0, 0.1)

            &::-webkit-scrollbar-thumb:hover
                background: rgba(0, 0, 0, 0.15)

            &::-webkit-scrollbar-thumb:active
                background: rgba(0, 0, 0, .2)

        &-container > div
            @include media-breakpoint-down(md)
                padding-left: 0
                padding-right: 0

        &__title, &__category
            display: inline-block
            width: 100%
            font-size: 1.5rem
            @include media-breakpoint-between(sm, md)
                font-size: 1.3rem
            @include media-breakpoint-down(sm)
                font-size: 1rem

        &__arrow
            padding-right: 10px
            transition: padding-right .25s

        &__container
            @include media-breakpoint-between(lg, xl)
                display: table
                width: 100%
                min-height: 7.5rem
                div
                    display: table-cell
                    vertical-align: middle
                .job-list__title
                    width: calc(100% / 12 * 5)
                .job-list__category
                    padding-left: 3rem
                    width: calc(100% / 12 * 7)

        &__item:hover .job-list__arrow
            padding-right: 0

        &__item
            border: #eaeaec 1px solid
            border-left-width: 0
            border-right-width: 0

            @include media-breakpoint-down(md)
                border-top: none

            &:nth-of-type(even):not(.other)
                background: #e9fbff

            a
                color: #828282
                cursor: pointer

                &:hover
                    text-decoration: none

            &.other
                color: #8c8c8c
                font-weight: bold

            .row
                padding: 1.5rem 3rem
                @include media-breakpoint-down(md)
                    position: relative
                    padding: 1rem 15px

                .job-list__title
                    @include media-breakpoint-down(md)
                        padding-top: 1rem
                        padding-right: 40px

                .job-list__category
                    @include media-breakpoint-down(md)
                        position: static
                        padding-bottom: 1rem
                        padding-right: 40px

                .job-list__category .job-list__arrow
                    float: right
                    position: absolute
                    right: -20px
                    top: 50%
                    transform: translateY(-50%)

                .job-list__category .job-list__arrow
                    @include media-breakpoint-down(md)
                        right: 30px
                        transform: scale(.7) translateY(-50%)
                        top: 42%

        .remarks
            cursor: pointer
            margin-top: 1rem
            text-align: center
            color: #555
            font-size: 1.5rem
            @include media-breakpoint-down(md)
                display: none
                font-size: 1rem

            &::after
                @include media-breakpoint-down(md)
                    display: none
                content: " "
                height: 1rem
                width: 1rem
                margin: auto
                border-right: solid
                border-bottom: solid
                border-color: #aaa
                transform: rotate(45deg)
                display: block
</style>
